import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsCostGridLots extends Component{ 

    constructor(props){
      super(props);

      this.state={
          costgridlots:[],
          modalTitle:"",
          costgridlotname:"",
          costgridlotid:0,

          CostGridLotIdFilter:"",
          CostGridLotNameFilter:"",
          costgridlotsWithoutFilter:[],
          costgridlotNames: [],
          costgridlotExists: false, 
      }
  }

  FilterFn(){
    var CostGridLotIdFilter=this.state.CostGridLotIdFilter;
    var CostGridLotNameFilter = this.state.CostGridLotNameFilter;

    var filteredData=this.state.costgridlotsWithoutFilter.filter(
        function(el){
            return el.costgridlotid.toString().toLowerCase().includes(
                CostGridLotIdFilter.toString().trim().toLowerCase()
            )&&
            el.costgridlotname.toString().toLowerCase().includes(
                CostGridLotNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({costgridlots:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.costgridlotsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({costgridlots:sortedData});

}

changeCostGridLotIdFilter = (e)=>{
  this.state.CostGridLotIdFilter=e.target.value;
  this.FilterFn();
}
changeCostGridLotNameFilter = (e)=>{
  this.state.CostGridLotNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/costgridlots/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({costgridlots:data,costgridlotsWithoutFilter:data});
  });
}

fetchCostGridLotNames() {
  axiosService.get('/costgridlots/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const costgridlotNames = data.map(item => item.costgridlotname);
      this.setState({ costgridlotNames: costgridlotNames });
    })
    .catch(error => {
      console.error("Error fetching costgridlot names:", error);
    });
}

checkCostGridLotExists = (event) => {
  const enteredCostGridLot = event.target.value.toLowerCase(); // Convert to lowercase
  const { costgridlotNames } = this.state;
  const costgridlotExists = costgridlotNames.some((costgridlot) => costgridlot.toLowerCase() === enteredCostGridLot);
  this.setState({ costgridlotExists });
};


componentDidMount(){
  this.refreshList();
  this.fetchCostGridLotNames();
}
changeCostGridLotName =(e)=>{
  this.setState({costgridlotname:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add CostGridLot",
      costgridlotid:0,
      costgridlotname: "",
      costgridlotExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit CostGridLot",
      costgridlotid:dep.costgridlotid,
      costgridlotname:dep.costgridlotname,
      initialCostgridlotname:dep.costgridlotname,
      costgridlotExists: false,

  });
}

createClick() {
  const { costgridlotname, costgridlotNames } = this.state;

  if (!costgridlotname) {
    alert('CostGridLot Name is required');
    return;
  }

  if (costgridlotNames.some(name => name.toLowerCase() === costgridlotname.toLowerCase())) {
    alert('CostGridLot already exists. Please provide a unique CostGridLot Name.');
    return;
  }


  axiosService.post('/costgridlots/', {
    costgridlotname: costgridlotname
  })
    .then(result => {
      alert('CostGridLot created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { costgridlotname, initialCostgridlotname, costgridlotNames } = this.state;

  // Check if any changes are detected
  if (
    costgridlotname === initialCostgridlotname
  ) {
    alert('No changes detected');
    return;
  }

  if (
    costgridlotNames.some(
      (existingCostGridLot) =>
        existingCostGridLot.toLowerCase() === costgridlotname.toLowerCase()
    )
  ) {
    alert('CostGridLot already exists. Please provide a unique CostGridLot Name.');
    return;
  }

  if (!costgridlotname) {
    alert('CostGridLot Name is required');
    return;
  }

  axiosService.patch('/costgridlots/'+id+'/',{
      costgridlotid:this.state.costgridlotid,
      costgridlotname:this.state.costgridlotname
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/costgridlots/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      costgridlots,
      modalTitle,
      costgridlotid,
      costgridlotname,
      costgridlotExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridLotIdFilter}
      placeholder="Filter"/>

      </div>
      CostGridLotId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridLotNameFilter}
      placeholder="Filter"/>

      </div>
      CostGridLot

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {costgridlots.map(dep=>
      <tr key={dep.costgridlotid} className="row-hover">
          <td className="table-text">{dep.costgridlotid}</td>
          <td className="table-text">{dep.costgridlotname}</td>
          <td className="table-text">

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >CostGridLot</span>
          <input
            type="text"
            className={`form-control ${costgridlotExists ? "is-invalid" : ""}`}
            value={costgridlotname}
            onChange={this.changeCostGridLotName}
            onBlur={this.checkCostGridLotExists}
            style={{ fontSize: "12px" }} 
          />
          {costgridlotExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >CostGridLot already exists.</div>}
        </div>

        {costgridlotid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {costgridlotid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(costgridlotid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

